import application from 'application/application';

application

	.directive('ngScrollmax', ['$timeout', '$parse', ($timeout, $parse) => ({
		restrict: 'A',
		link(scope, element, attributes) {

			let { scrollmaxRef, scrollmaxOffset, scrollmaxStop } = attributes;

			scrollmaxOffset = parseInt(scrollmaxOffset, 10) || 100;

			if (scrollmaxRef === 'self') {

				$(element).on('scroll', () => {
					const { scrollTop, scrollHeight, clientHeight } = element[0];

					if ((Math.round(scrollTop) + clientHeight) >= (scrollHeight - scrollmaxOffset)) {

						$('[ng-scrollmax]:visible').each(function() {

							if (scope[scrollmaxStop] === true) {
								$(this).triggerHandler('scrollmax');
							}

						});

					}
				});
			}

			$(element).on('scrollmax', () => $parse(attributes.ngScrollmax)(scope));

		}
	})]);
